import Button from 'components/buttons/button';
import PremiumFlag from 'components/premium/MultiplierFlag';
import coinIcon from 'images/icons/coin.svg';
import { cn } from 'lib/utils';
import Img from 'next/image';
import PropTypes from 'prop-types';

const CoinButton = ({
  children,
  className,
  handleClick,
  id,
  selected,
  type,
  destination,
}) => {
  const buttonClicked = () => {
    handleClick({ id });
  };

  if (type === 'link') {
    return (
      <Button
        className={cn('w-full', className, selected && 'button-active')}
        key={id}
        href={destination}
        theme="animated"
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      className={cn(className, selected && 'button-active')}
      key={id}
      onClick={buttonClicked}
      preventDefault
      theme="outline"
    >
      {children}
    </Button>
  );
};

const ButtonGrid = ({
  data,
  handleButtonClick,
  selectedButtonId,
  isSubscriber,
}) => {
  const contentFactory = (type, label, coins) => {
    if (type === 'link') {
      // Link style button
      return label;
    } else {
      // Coin value style button
      return (
        <>
          <Img src={coinIcon} alt="" height="24" width="24" />
          <div className="text-left leading-tight">
            <h5 className="font-semibold">{`${label}`}</h5>
            <h6 className="text-sm font-normal text-stone-500">
              {`${coins.toLocaleString()} coins`}
              {isSubscriber ? (
                <PremiumFlag isSubscriber={isSubscriber} />
              ) : null}
            </h6>
          </div>
        </>
      );
    }
  };

  const isPremiumLink = (type, dropFor) =>
    type === 'link' && dropFor.includes('premium');

  return (
    <div className="mb-2 grid grid-cols-2 gap-2">
      {data.map((b) => {
        const { id, type, label, destination, coins, dropFor } = b;
        const premiumLink = isPremiumLink(type, dropFor);
        if (premiumLink && isSubscriber) {
          return null;
        }
        return (
          <CoinButton
            key={id}
            id={id}
            type={type}
            destination={destination}
            handleClick={handleButtonClick}
            selected={selectedButtonId === id}
          >
            {contentFactory(type, label, coins)}
          </CoinButton>
        );
      })}
    </div>
  );
};

CoinButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.any.isRequired,
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['link', 'amount']),
  destination: PropTypes.string,
};

ButtonGrid.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      type: PropTypes.oneOf(['link', 'amount']),
      destination: PropTypes.string,
      label: PropTypes.string.isRequired,
      coins: PropTypes.number,
    })
  ).isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  selectedButtonId: PropTypes.any.isRequired,
};

export { ButtonGrid, CoinButton };
